import React from "react";
import styled from "styled-components";
import NavLink from "react-router-dom/NavLink";
import { withProps } from "recompose";

import Button from "package-common-react/lib/components/Button";

import { mixin, get } from "package-common-react/lib/style/util";

export const Home = styled.div`
  background: ${get("color.background")};
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 1;
  height: calc(100vh - 50px);
  justify-content: space-between;
  margin: -25px;
  padding: 25px;
`;

export const Header = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background: #00378e;
  margin: -25px -25px 0 -25px;
  padding: 25px 40px 75px 40px;
  position: relative;

  &:after {
    background: ${get("color.background")} url("/assets/images/home-delimiter.png")
      no-repeat bottom center;
    background-size: 100% 75px;
    bottom: 0;
    content: "";
    display: block;
    height: 75px;
    left: 0;
    position: absolute;
    right: 0;
  }
`;

export const PlayButton = styled(
  withProps({
    primary: true,
  })(
    Button.withComponent(function({ primary, ...props }) {
      return <NavLink {...props} />;
    })
  )
)``;

export const EndButton = Button;

export const ImageLogo = styled(function({ className, ...props }) {
  return (
    <div className={className}>
      <img alt="" {...props} />
    </div>
  );
})`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 3;

  img {
    height: auto !important;
    max-height: 100%;
    max-width: none !important;
    object-fit: contain;
    width: 100%;
  }
`;

export const Action = styled.div`
  flex: 0;
  margin: 0 0 25px 0;
`;

export const LoadingText = styled.p`
  ${mixin("font.bold", 16, "20px")};
  color: #fff;
  margin: 0;
  padding: 15px;
  text-align: center;
`;

export const Footer = styled.footer`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const HomeText = styled(function({where, condition, className, children}) {
  return <div className={className}>
    <div className="headline">{children}</div>
    <span className="where">{where}</span>
    <span className="condition">{condition}</span>
  </div>
})`
  .headline {
    align-items: center;
    color: ${get('color.red')};
    display: flex;
    justify-content: center;
    padding: 0.75em 0;
    svg {
      fill: currentColor;
      width: 100%;
  }
  }
  .where {
    ${mixin('font.bold', 20)};
    color: ${get('color.red')};
    display: block;
    padding: 0 0.15em;
  }
  .condition {
    ${mixin('font.default', 18)};
    color: ${get('color.primaryText')};
    display: block;
    margin: 10px 0;
    padding: 0 0.15em;
  }
`;



// WEBPACK FOOTER //
// ./src/components/HomeContent/style.js